module.exports = __webpack_public_path__ + "img/afp.118a4172.jpg";